import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS, KeyImageLabel } from '@/api';
import { fetcher } from '@/api/fetcher';

export const useKeyImageLabelUpdaterMutation = () => {
  const keyImageLabelUpdater = async (keyImageUuid: string, payload: Partial<KeyImageLabel>) => {
    const { data } = await fetcher.FCT.patch<KeyImageLabel>(
      `${ENDPOINTS.FCT.KEY_IMAGE.BASE}${keyImageUuid}`,
      payload,
    );

    return data;
  };

  const mutation = useMutation({
    mutationFn: ({
      keyImageUuid,
      payload,
    }: {
      keyImageUuid: string;
      payload: Partial<KeyImageLabel>;
    }) => keyImageLabelUpdater(keyImageUuid, payload),
  });

  return mutation;
};
